import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import "../../../assets/Montserrat/stylesheet.css";
import SelectedDoctor from "../../../components/kit/SelectedDoctor/SelectedDoctor";
import { currentDate } from "../../../global/Constants/Constants";
import * as appointmentActions from "../../../redux/actions/appointmentActions";
import * as doctorActions from "../../../redux/actions/doctorActions";
import * as userActions from "../../../redux/actions/userActions";
import ChooseMedService from "../OnlineRecord/ChooseMedService";
import SimpleAlert from "./Alert/SimpleAlert";
import ChooseMaster from "./ChooseMaster";
import ChoiceServices from "./ChoiceServices";
import ClientForm from "./ClientForm/ClientForm.jsx";
import "./index.scss";
import LoadingComponent from "./LoadingComponent/LoadingComponent";
import { api, handleError } from "./../../../api/apiUtils";
import OnlineRecordModal from "./OnlineRecordModal/OnlineRecordModal";
import Payment from "./Payment/Payment";
import SelectDate from "./SelectDate/SelectDate";
import { showGenderInput } from "./../../../constants.json";
import withReactContent from "sweetalert2-react-content";
import AllSevices from "./AllSevices";
import ChoiseDoctor from "./ChoiseDoctor";
import { CREATE_PATIENT } from "../../../global/Constants/appointment.js";

const Swal = require("../../../scripts/sweetalert.min.js");

class OnlineRecord extends Component {
  state = {
    isLoading: true,
    page: 1,
    services: [],
    time: "",
    name: "",
    lastname: "",
    sname: "",
    gender: showGenderInput ? -1 : 0,
    phone: "",
    DateBirth: "",
    doctype: -1,
    docnum: "",
    master: null,
    masterPhoto: "",
    selectedDate: currentDate,
    isOpenModal: false,
    doctorId: 0,
    selectedSpecialityId: null,
    selectedServiceId: null,
  };

  onSelectSpecialityId = (id) => {
    this.setState({ selectedSpecialityId: id });
  };
  onSelectServiceId = (id) => {
    this.setState({ selectedServiceId: id });
  };

  componentDidMount() {
    this.props
      .authWebApiUser()
      .then((user) => {
        this.setState({ user });
        this.setState({ errorMessage: "" });
        this.props
          .loadDoctors()
          .then(() => {
            this.setState({ doctors: this.props.doctors });
            this.setState({ isLoading: false });
            this.setState({ errorMessage: "" });
          })
          .catch((error) => {
            this.setState({ errorMessage: "Ошибка загрузки врачей: " + error });
          });
      })
      .catch((error) => {
        this.setState({ errorMessage: "Ошибка авторизации: " + error });
      });

    this.setState({ currentMonth: new Date().getMonth() + 1 });
  }

  onSelectService = (variant) => {
    this.setState({ page: variant });
  };

  inputChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSelectTime = (time) => {
    this.setState({ time });
    let duration = this.state.doctorTime * 60000;
    var timeArr = time.split(":");
    var minutes = +timeArr[0] * 60 + +timeArr[1];
    var date = new Date(this.state.selectedDate.toDateString());
    var startTime = date.getTime() + minutes * 60000;
    var endTime = startTime + duration;
    var startDateTime =
      new Date(startTime).toDateString("yyyy-MM-dd") +
      " " +
      new Date(startTime).toLocaleTimeString();
    var endDateTime =
      new Date(endTime).toDateString("yyyy-MM-dd") +
      " " +
      new Date(endTime).toLocaleTimeString();
    this.setState({ startDateTime });
    this.setState({ endDateTime });
  };

  onSelectMaster = (
    master,
    id,
    time,
    doctorSpecialities,
    masterPhoto,
    selectedSpecialityId,
  ) => {
    this.setState({ doctorId: id });
    this.setState({ master }, () => this.handleClickNext());
    this.setState({ doctorTime: time });
    this.setState({ doctorSpecialities });
    if (this.state.page === 2 || this.state.page === 7) {
      this.setState({ services: [] });
    }
    this.setState({ busyDays: null });
    this.setState({ freeTimes: [] });
    this.setState({ selectedDate: currentDate });
    this.setState({ masterPhoto: masterPhoto });
    this.setState({ selectedSpecialityId: selectedSpecialityId });
  };

  handleEmptyService = () => {
    this.setState({ services: [] });
  };

  handleClickNext = () => {
    if (this.state.page === 2) {
      this.setState({ page: 3 });
      this.changeMonth();
    } else if (this.state.page === 8) {
      this.setState({ page: 9 });
      this.changeMonth();
    } else {
      this.setState({ page: this.state.page + 1 });
    }
  };

  handleClickPrev = () => {
    if (this.state.page === 3) {
      this.setState({ page: 2 });
      this.changeMonth();
    } else {
      this.setState({ page: this.state.page - 1 });
    }
  };

  mainPageLinck = () => {
    this.setState({ page: 1 });
  };

  choiceServiceClickNext = () => {
    this.setState({ page: 7 });
  };

  choiceServiceClickPrev = () => {
    this.setState({ page: 2 });
  };

  toggleModal = () => {
    this.setState({ isOpenModal: !this.state.isOpenModal });
  };
  onCloseModal = () => {
    this.setState({ isOpenModal: false });
    if (this.state.isOpenModal) {
      // TODO remove it
      this.setState({
        page: 1,
        services: [],
        time: "",
        name: "",
        lastname: "",
        sname: "",
        gender: -1,
        phone: "",
        DateBirth: "",
        doctype: -1,
        docnum: "",
        master: null,
        selectedDate: "",
      });
    }
  };

  onSelectDate = (date) => {
    this.setState({ isLoading: true });
    this.setState({ selectedDate: date });
    let selDate = new Date(date).toDateString("yyyy-MM-dd");
    let data = {
      date: selDate,
      doctorId: this.state.doctorId,
      checkCurrentDate: true,
      phone: this.state.phone,
    };
    this.props
      .loadFreeAppointments(data)
      .then(() => {
        let freeTimes = [];
        this.props.appointments.forEach((element) => {
          freeTimes.push(getTimePart(new Date(element.StartTime)));
        });
        this.setState({ freeTimes });
        this.setState({ errorMessage: "" });
        this.setState({ isLoading: false });
      })
      .catch(() => {
        this.setState({
          errorMessage:
            "Ошибка загрузки свободного времени: Пожалуйста перезагрузите страницу!",
        });
        this.setState({ isLoading: false });
      });
  };

  calendarHandleNextClick = () => {
    const { selectedDate } = this.state;
    const selectedMonth = selectedDate.getMonth() + 1;
    this.setState({
      selectedDate: new Date(selectedDate.setMonth(selectedMonth)),
    });
    this.setState({ busyDays: null });
    this.setState({ freeTimes: [] });
    this.changeMonth();
  };

  calendarHandlePrevClick = () => {
    const { selectedDate } = this.state;
    const selectedMonth = selectedDate.getMonth() - 1;
    this.setState({
      selectedDate: new Date(selectedDate.setMonth(selectedMonth)),
    });
    this.setState({ busyDays: null });
    this.setState({ freeTimes: [] });
    this.changeMonth();
  };

  changeMonth = () => {
    const selectedDate = this.state.selectedDate;
    const selectedMonth = selectedDate.getMonth() + 1;
    if (this.state.currentMonth <= selectedMonth) {
      const year = selectedDate.getFullYear();
      let data = {
        month: selectedMonth,
        year: year,
        doctorId: this.state.doctorId,
      };
      this.props
        .loadBusyDays(data)
        .then(() => {
          this.setState({ busyDays: this.props.appointments });
          this.setState({ errorMessage: "" });
        })
        .catch((error) => {
          this.setState({
            errorMessage: "Ошибка загрузки нерабочих и занятых дней: " + error,
          });
          setTimeout(() => window.location.reload(), 3000);
        });
    }
    if (new Date().getMonth() + 1 !== this.state.selectedDate.getMonth() + 1) {
      Array.from(
        document.querySelectorAll(".react-calendar__tile--active"),
      ).forEach((el) => {
        el.classList.add("bd-none");
      });
    }
  };

  createPatient = () => {
    const patientData = {
      LastName: this.state.lastname,
      FirstName: this.state.name,
      Sex: this.state.gender === 1,
      MiddleName: this.state.sname,
      DateBirth: this.state.DateBirth,
      MobilePhone: this.state.phone
        .replace(/[^\d]/g, "")
        .split("")
        .splice(1)
        .join(""),
      // Email: this.state.email,
    };

    api
      .post(CREATE_PATIENT, patientData)
      .then((response) => {
        if (response) {
          this.setState({ ShortGUID: response.data.Data.ShortGUID });
          this.handleClickNext();
        }
      })
      .catch((error) => {
        console.error("Error creating patient:", error);
      });
  };

  onSubmit = () => {
    const startDateTime = new Date(this.state.startDateTime);
    const endDateTime = new Date(this.state.endDateTime);

    const startDateTimeFormatted = new Date(
      startDateTime.getTime() - startDateTime.getTimezoneOffset() * 60000,
    )
      .toISOString()
      .slice(0, 19);

    const endDateTimeFormatted = new Date(
      endDateTime.getTime() - endDateTime.getTimezoneOffset() * 60000,
    )
      .toISOString()
      .slice(0, 19);

    let appointmentData = {
      FromDateTime: startDateTimeFormatted,
      ToDateTime: endDateTimeFormatted,
      DoctorId: this.state.doctorId,
      Services: this.state.services.map((a) => a.Id),
      PatientGuid: this.state.ShortGUID,
      doctorPhone: this.state.doctorPhone,
      PutInAQueue: true,
    };
    this.setState({ isLoading: true });
    this.props
      .createAppointment(appointmentData)
      .then(() => {
        this.toggleModal();
        this.setState({ isLoading: false });
        this.setState({ errorMessage: "" });
      })
      .catch(() => {
        this.setState({ isLoading: false });
        this.setState({ errorMessage: "" });
        Swal.fire({
          icon: "info",
          title: "Упс...",
          text: "Данное время уже занято, выберите другое удобное Вам время!",
          showConfirmButton: true,
          confirmButtonText: "Перейти в календарь",
          confirmButtonColor: "red",
        }).then((result) => {
          if (result.isConfirmed) {
            this.setState({ page: 2 });
            this.onSelectDate(this.state.selectedDate);
          }
        });
      });
  };

  render() {
    const {
      page,
      isLoading,
      services,
      time,
      name,
      lastname,
      sname,
      gender,
      phone,
      DateBirth,
      doctype,
      docnum,
      master,
      isOpenModal,
      selectedDate,
    } = this.state;

    return (
      <React.Fragment>
        {isLoading ? (
          <LoadingComponent errorMessage={this.state.errorMessage} />
        ) : (
          <div className="container">
            {this.state.errorMessage && (
              <SimpleAlert
                severity="error"
                errorMessage={this.state.errorMessage}
              />
            )}
            {page === 1 && (
              <ChoiceServices
                choiceServiceClickNext={this.choiceServiceClickNext}
                choiceServiceClickPrev={this.choiceServiceClickPrev}
              />
            )}
            {page === 2 && (
              <div className="online-record-root">
                <ChooseMaster
                  onSelectMaster={this.onSelectMaster}
                  errorMessage={this.state.errorMessage}
                  handleClickPrev={this.handleClickPrev}
                />
              </div>
            )}
            {page === 3 && (
              <div className="online-record-root">
                <div>
                  <SelectedDoctor
                    master={master}
                    masterPhoto={this.state.masterPhoto}
                    doctorSpecialities={this.state.doctorSpecialities}
                  />
                  <SelectDate
                    selectedTime={this.state.time}
                    onSelectTime={this.onSelectTime}
                    inputChangeHandler={this.inputChangeHandler}
                    onSelectDate={this.onSelectDate}
                    selectedDate={selectedDate}
                    calendarHandleNextClick={this.calendarHandleNextClick}
                    calendarHandlePrevClick={this.calendarHandlePrevClick}
                    handleClickNext={this.handleClickNext}
                    times={this.state.freeTimes}
                    timesBtnsLoading={this.state.timesBtnsLoading}
                    doctorId={this.state.doctorId}
                    doctorSpecialities={this.state.doctorSpecialities}
                    selectedSpecialityId={this.state.selectedSpecialityId}
                    busyDays={this.state.busyDays}
                    handleClickPrev={this.handleClickPrev}
                  />
                </div>
              </div>
            )}
            {page === 4 && (
              <div className="online-record-root 123456">
                <div>
                  <SelectedDoctor
                    master={master}
                    masterPhoto={this.state.masterPhoto}
                    doctorSpecialities={this.state.doctorSpecialities}
                  />
                  <ChooseMedService
                    onSelect={this.onSelectServiceVariant}
                    selectedOptions={services}
                    handleClickNext={this.handleClickNext}
                    doctors={this.props.doctors}
                    doctorId={this.state.doctorId}
                    doctorTime={this.state.doctorTime}
                    startDateTime={this.state.startDateTime}
                    endDateTime={this.state.endDateTime}
                    doctorSpecialities={this.state.doctorSpecialities}
                    handleClickPrev={this.handleClickPrev}
                    handleEmptyService={this.handleEmptyService}
                    errorMessage={this.state.errorMessage}
                    selectedSpecialityId={this.state.selectedSpecialityId}
                  />
                </div>
              </div>
            )}
            {page === 5 && (
              <div className="online-record-root">
                <ClientForm
                  name={name}
                  lastname={lastname}
                  sname={sname}
                  gender={gender}
                  phone={phone}
                  DateBirth={DateBirth}
                  doctype={doctype}
                  docnum={docnum}
                  inputChangeHandler={this.inputChangeHandler}
                  handleClickNext={this.handleClickNext}
                  handleClickPrev={this.handleClickPrev}
                  createPatient={this.createPatient}
                />
              </div>
            )}
            {page === 6 && (
              <div className="online-record-root">
                <Payment
                  selectedOptions={services}
                  selectedTime={time}
                  master={master}
                  selectedDate={selectedDate}
                  onSubmit={this.onSubmit}
                  masterPhoto={this.state.masterPhoto}
                  handleClickNext={this.handleClickNext}
                  handleClickPrev={this.handleClickPrev}
                  doctorSpecialities={this.state.doctorSpecialities}
                />
              </div>
            )}

            {page === 7 && (
              <div className="online-record-root two">
                <AllSevices
                  onSelectSpecialityId={this.onSelectSpecialityId}
                  onSelectServiceId={this.onSelectServiceId}
                  onSelect={this.onSelectServiceVariant}
                  selectedOptions={services}
                  handleClickNext={this.handleClickNext}
                  doctors={this.props.doctors}
                  doctorId={this.state.doctorId}
                  doctorTime={this.state.doctorTime}
                  startDateTime={this.state.startDateTime}
                  endDateTime={this.state.endDateTime}
                  doctorSpecialities={this.state.doctorSpecialities}
                  handleClickPrev={this.handleClickPrev}
                  errorMessage={this.state.errorMessage}
                  selectedSpecialityId={this.state.selectedSpecialityId}
                  mainPageLinck={this.mainPageLinck}
                  onSelectMaster={this.onSelectMaster}
                />
              </div>
            )}

            {page === 8 && (
              <div className="online-record-root two">
                <ChooseMaster
                  onSelectMaster={this.onSelectMaster}
                  errorMessage={this.state.errorMessage}
                  AllSevices
                  selectedService={this.state.selectedServiceId}
                  selectedSpecialityId={this.state.selectedSpecialityId}
                  handleClickNext={this.handleClickNext}
                  handleClickPrev={this.handleClickPrev}
                  handleEmptyService={this.handleEmptyService}
                />
              </div>
            )}

            {page === 9 && (
              <div className="online-record-root">
                <div>
                  <SelectedDoctor
                    master={master}
                    masterPhoto={this.state.masterPhoto}
                    doctorSpecialities={this.state.doctorSpecialities}
                  />
                  <SelectDate
                    selectedTime={this.state.time}
                    onSelectTime={this.onSelectTime}
                    inputChangeHandler={this.inputChangeHandler}
                    onSelectDate={this.onSelectDate}
                    selectedDate={selectedDate}
                    calendarHandleNextClick={this.calendarHandleNextClick}
                    calendarHandlePrevClick={this.calendarHandlePrevClick}
                    handleClickNext={this.handleClickNext}
                    times={this.state.freeTimes}
                    timesBtnsLoading={this.state.timesBtnsLoading}
                    doctorId={this.state.doctorId}
                    doctorSpecialities={this.state.doctorSpecialities}
                    selectedSpecialityId={this.state.selectedSpecialityId}
                    busyDays={this.state.busyDays}
                    handleClickPrev={this.handleClickPrev}
                  />
                </div>
              </div>
            )}
            {page === 10 && (
              <div className="online-record-root">
                <ClientForm
                  name={name}
                  lastname={lastname}
                  sname={sname}
                  gender={gender}
                  phone={phone}
                  DateBirth={DateBirth}
                  doctype={doctype}
                  docnum={docnum}
                  inputChangeHandler={this.inputChangeHandler}
                  handleClickNext={this.handleClickNext}
                  handleClickPrev={this.handleClickPrev}
                  createPatient={this.createPatient}
                />
              </div>
            )}
            {page === 11 && (
              <div className="online-record-root">
                <Payment
                  selectedOptions={services}
                  selectedTime={time}
                  master={master}
                  selectedDate={selectedDate}
                  onSubmit={this.onSubmit}
                  masterPhoto={this.state.masterPhoto}
                  handleClickNext={this.handleClickNext}
                  handleClickPrev={this.handleClickPrev}
                  doctorSpecialities={this.state.doctorSpecialities}
                />
              </div>
            )}

            {isOpenModal && (
              <OnlineRecordModal
                isOpenModal={isOpenModal}
                onClose={this.onCloseModal}
                SpecialityId={services[0].SpecialityId}
              />
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

OnlineRecord.propTypes = {
  appointments: PropTypes.array.isRequired,
  createAppointment: PropTypes.func.isRequired,
  loadFreeAppointments: PropTypes.func.isRequired,
  authWebApiUser: PropTypes.func.isRequired,
  user: PropTypes.object,
  freeTimes: PropTypes.object,
  doctors: PropTypes.array.isRequired,
  loadDoctors: PropTypes.func.isRequired,
  busyDays: PropTypes.array,
  loadBusyDays: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appointments: state.appointments,
    user: state.user,
    doctors: state.doctors,
    services: state.services,
    busyDays: state.busyDays,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createAppointment: (appointment) =>
      dispatch(appointmentActions.createAppointment(appointment)),
    loadFreeAppointments: (appointment) =>
      dispatch(appointmentActions.loadFreeAppointments(appointment)),
    authWebApiUser: (user) => dispatch(userActions.authWebApiUser(user)),
    loadDoctors: (doctor) => dispatch(doctorActions.loadDoctors()),
    loadBusyDays: (data) => dispatch(appointmentActions.loadBusyDays(data)),
  };
}

function getTimePart(date) {
  var h = (date.getHours() < 10 ? "0" : "") + date.getHours();
  var m = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
  return h + ":" + m;
}

export default connect(mapStateToProps, mapDispatchToProps)(OnlineRecord);
